import { useSelector } from 'react-redux';

import { selectEtazhiBlackFridayPromoOffersData } from 'shared/selectors/etazhiBlackFriday';
import { getIsStartDatePassed } from 'shared/utils/etazhiBlackFriday';

export function usePromoOffersVisibility() {
  const promoOffersData = useSelector(selectEtazhiBlackFridayPromoOffersData);
  const isPromoOffersEnabled = !!promoOffersData?.enabled;
  const isStartDatePassed = getIsStartDatePassed(promoOffersData);

  return isPromoOffersEnabled && isStartDatePassed;
}
